'use client';

import { useMemo } from 'react';

import { usePathname } from 'next/navigation';

const EXCLUDE_LIST = {
  // Most accurate shipping price (excludes /pay/success/)
  CHECKOUT: /\/pay(?!\/success\/)/,

  // No product prices displayed
  // AUTH
  SIGNUP: /\/signup($|\/)/,
  MAGIC_LINK: /\/magic-link($|\/)/,
  LOGIN: /\/login($|\/)/,
  AUTH_EXAMPLE: /\/auth-example\/?$/,
  EMAIL_CHANGE: /\/email-change($|\/)/,
  PASSWORD_RESET: /\/password-reset\/?$/,

  // OUTFITS
  OUTFITS_MODERATE: /\/outfits\/moderate\/?$/,
  OUTFITS_COLLAGE: /\/outfits\/collage($|\/)/,

  // LISTING
  SELLING_HUB: /\/sellinghub($|\/)/,
  MANAGE_PRODUCT: /\/products\/[^\/]+\/manage/,
  CREATE_PRODUCT: /\/products\/create($|\/)/,
  EDIT_PRODUCT: /\/products\/edit($|\/)/,
  SHOP_DROP: /\/[a-zA-Z0-9]+\/drop\/?$/,

  // MISC
  BLOG: /\/blog($|\/)/,
  CAMPAIGN: /\/campaign($|\/)/,
  COLLECT_TAX_INFORMATION: /\/collect-tax-information($|\/)/,
  DISPUTES: /\/disputes($|\/)/,
  EBAY_CALLBACK: /\/ebay\/callback($|\/)/,
  MARKETING: /\/marketing($|\/)/,
  PARTNERS: /\/partners($|\/)/,
  PURCHASES: /\/purchases($|\/)/,
  SELL: /\/sell\/?$/,
  SETTINGS: /\/settings($|\/)/,
  SHIPPING: /\/shipping\/?$/,
  SITE_MAP: /\/site-map($|\/)/,
  START_SELLING: /\/start-selling($|\/)/,
  STORIES: /\/stories($|\/)/,
  STYLE_QUIZ: /\/find-your-style($|\/)/,
  YOUTUBE_LANDING: /\/youtubelanding\/?$/,
  ZENDESK: /\/zendesk\/?$/,
} as const;

export function useUpfrontShippingBannerVisibility() {
  const pathname = usePathname();

  const shouldHide = useMemo(
    () =>
      Object.values(EXCLUDE_LIST).some((expression) =>
        expression.test(pathname)
      ),
    [pathname]
  );

  return { shouldHide };
}
